import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import NewRirekishoExampleSentenceDialog from '@/components/format-edit/new-rirekisho/NewRirekishoExampleSentenceDialog.vue'
import AiMyprDialog from '@/components/format-edit/AiMyprDialog.vue'
import AiMyprDialogHeader from '@/components/format-edit/AiMyprDialogHeader.vue'
import AiMyprPrQuestionsForm from '@/components/format-edit/AiMyprPrQuestionsForm.vue'
import { useHostServices } from '@/composables/format-edit/useHostServices'
import {
  useShokurekishoFormatData,
  toExampleDialogItems,
  type ShokurekishoExampleSentences
} from '@/composables/format-edit/useShokurekishoFormatData'
import { useShokurekishoAiMypr } from '@/composables/format-edit/useShokurekishoAiMypr'
import '@/assets/css/ai-streaming.css'


export default /*#__PURE__*/_defineComponent({
  __name: 'ShokurekishoPrMessageCard',
  props: {
    currentCardId: null,
    exampleSentences: null
  },
  setup(__props: any) {

const props = __props as {
  currentCardId?: string
  exampleSentences?: ShokurekishoExampleSentences
};



const formatData = useShokurekishoFormatData()
const { globalVar } = useHostServices()
const exampleVisible = ref(false)

const inAppPayments = computed(
  () =>
    !!(globalVar as typeof globalVar & { in_app_payments?: boolean })
      .in_app_payments
)
const isYagiPrime = computed(() => !!globalVar.isYagiPrime)

const prExamples = computed(() =>
  toExampleDialogItems(
    props.exampleSentences?.prMessage,
    formatData.occupation || 'others'
  )
)

const {
  aiMyprVisible,
  useDigram,
  aiResultView,
  aiResultMyprResult,
  aiUsageCount,
  aiMaxUsageCount,
  aiIsStreaming,
  aiIsThinking,
  aiThinkingLabel,
  aiReasoningText,
  aiShowReasoning,
  showAiMyprDialog,
  closeDialog,
  getAIMypr,
  goYagiprimeRegister,
  applyMyprResult,
  toggleAiReasoning,
  cancelAIStream
} = useShokurekishoAiMypr(formatData)

function onSelectExample(item: { description: string }) {
  formatData.prMessage = item.description.replace(/<br>/gi, '\n')
}

function onMyprVisible(value: boolean) {
  aiMyprVisible.value = value
  if (!value) cancelAIStream()
}

return { __sfc: true,props, formatData, globalVar, exampleVisible, inAppPayments, isYagiPrime, prExamples, aiMyprVisible, useDigram, aiResultView, aiResultMyprResult, aiUsageCount, aiMaxUsageCount, aiIsStreaming, aiIsThinking, aiThinkingLabel, aiReasoningText, aiShowReasoning, showAiMyprDialog, closeDialog, getAIMypr, goYagiprimeRegister, applyMyprResult, toggleAiReasoning, cancelAIStream, onSelectExample, onMyprVisible, NewRirekishoExampleSentenceDialog, AiMyprDialog, AiMyprDialogHeader, AiMyprPrQuestionsForm }
}

})